import React from "react";
import { Link } from "react-router-dom";
import { Phone, Globe, Instagram, MessageCircle, Mail } from "lucide-react";

export default function Footer({ theme }) {
  const primaryColor = theme?.primaryColor || "#6b2118";
  const accentColor = theme?.accentColor || "#c9a84c";

  return (
    <footer style={{ background: "#2c1810", color: "rgba(255,255,255,0.75)", paddingTop: 60 }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 5vw" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 48, paddingBottom: 48 }}>
          {/* Brand */}
          <div>
            <div style={{ fontFamily: "Georgia, serif", fontSize: "1.5rem", color: accentColor, marginBottom: 8 }}>ACHU Health Mix</div>
            <div style={{ fontFamily: "cursive", fontSize: "0.95rem", color: "rgba(255,255,255,0.5)", marginBottom: 16 }}>"Specially Hand Made for You!"</div>
            <p style={{ fontSize: "0.83rem", lineHeight: 1.8 }}>100% Natural Multi Grain Drink with 27 carefully selected grains. No preservatives, no added sugar.</p>
            <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
              {[
                { icon: <MessageCircle size={16}/>, href: "https://wa.me/919840320932", label: "WhatsApp" },
                { icon: <Instagram size={16}/>, href: "https://instagram.com/achu.healthmix", label: "Instagram" },
              ].map(({ icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#fff", textDecoration: "none", transition: "background 0.2s",
                }}>{icon}</a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: "#fff", fontSize: "0.85rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: 20 }}>Quick Links</h4>
            {[["Home", "/"], ["Shop", "/shop"], ["About Us", "/about"], ["Contact", "/contact"], ["My Orders", "/orders"], ["Cart", "/cart"]].map(([label, path]) => (
              <Link key={path} to={path} style={{
                display: "block", color: "rgba(255,255,255,0.65)",
                textDecoration: "none", fontSize: "0.85rem",
                marginBottom: 10, transition: "color 0.2s",
              }}>{label}</Link>
            ))}
          </div>

          {/* Products */}
          <div>
            <h4 style={{ color: "#fff", fontSize: "0.85rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: 20 }}>Our Products</h4>
            {["Health Mix 250g", "Health Mix 500g", "Health Mix 1kg", "Bulk Pack 5kg"].map(label => (
              <Link key={label} to="/shop" style={{
                display: "block", color: "rgba(255,255,255,0.65)",
                textDecoration: "none", fontSize: "0.85rem", marginBottom: 10,
              }}>{label}</Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: "#fff", fontSize: "0.85rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: 20 }}>Contact Us</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[
                { icon: <Phone size={15}/>, text: "98403 20932", href: "tel:+919840320932" },
                { icon: <Phone size={15}/>, text: "96590 01122", href: "tel:+919659001122" },
                { icon: <Globe size={15}/>, text: "achuhealthmix.com", href: "https://www.achuhealthmix.com" },
                { icon: <Instagram size={15}/>, text: "@achu.healthmix", href: "https://instagram.com/achu.healthmix" },
              ].map(({ icon, text, href }) => (
                <a key={text} href={href} style={{ display: "flex", alignItems: "center", gap: 10, color: "rgba(255,255,255,0.65)", textDecoration: "none", fontSize: "0.85rem" }}>
                  <span style={{ color: accentColor }}>{icon}</span> {text}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", padding: "20px 0", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <p style={{ fontSize: "0.78rem" }}>© {new Date().getFullYear()} ACHU Health Mix. All rights reserved.</p>
          <div style={{ display: "flex", gap: 20 }}>
            {["Privacy Policy", "Terms & Conditions", "Refund Policy"].map(t => (
              <Link key={t} to="#" style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>{t}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
